import { LOG_LEVELS } from 'src/app/common/constants/Defines';

/**
 * The file contents for the current environment will overwrite these during build.
 * The build system defaults to the dev environment which uses `environment.ts`, but if you do
 * `ng build --env=prod` then `environment.prod.ts` will be used instead.
 * The list of which env maps to which file can be found in `angular-cli.json`.
 */
export const environment = {
  production: true,
  stubMode:  false,
  baseUrlMint: '/mint',
  baseUrlVluxgate: '/api/vluxgate',
  baseUrlNil: '/api', // only if we need a NIL Service, e.g. UserData_GET,
  OTDSBaseUrl: '/meinvodafone/services/api',
  paymentBaseUrl: '/meinvodafone/account',
  configPath: '/simplicity/payment/js/config/',
  configPathErrorMessages: '/simplicity/payment/js/config/',
  simplicityAssets: '/simplicity/assets/',
  svgIcons: '/simplicity/svgdefs.svg',
  featuresConfigPath: '/simplicity/payment/js/config/features.json',
  logLevel: LOG_LEVELS.LOG,
  cmsConfigPath: '/wording/payment/',
  cmsErrorMessagesPath: '/api-static/errormessages/',
  gmchatServiceUrl: '/gmchat',
  cmsCommonWording: '/config/deWording-core.json',

};
